
import { TableLazyLoadEvent } from 'primeng/table';
import { PaginationParams } from '../model/api/pagination-params';

export const pageSortChange = (paging: PaginationParams, merged: TableLazyLoadEvent): PaginationParams => {
    let p = { ...paging };
    if (typeof merged.first !== 'undefined' && merged.rows) {
        p = {
            ...p,
            page: Math.floor(merged.first / merged.rows) + 1,
            size: merged.rows,
        };
    }
    if (merged.sortField && merged.sortOrder) {
        p = {
            ...p,
            sort: merged.sortField.toString(),
            order: merged.sortOrder === -1 ? 'desc' : 'asc',
        };
    }
    return p;
};

export const pageChange = (paging: PaginationParams, merged: TableLazyLoadEvent): PaginationParams => {
    let p = { ...paging };
    if (typeof merged.first !== 'undefined' && merged.rows) {
        p = {
            ...p,
            page: Math.floor(merged.first / merged.rows) + 1,
            size: merged.rows,
        };
    }
    return p;
};
